<template>
  <div
    :class="{ 'hover-video': true, enable }"
    @mouseover="enable ? handleMouseOver() : null"
    @mouseleave="enable ? handleMouseLeave() : null"
  >
    <Resource
      :key="'poster'"
      :src="transformImage(poster, { width: 1048 })"
      class="video-poster"
      :style="{ display: hover ? 'none' : 'block' }"
      :alt="'industry-video-poster'"
    />
    <Transition name="fade" mode="out-in">
      <LazyVideo
        v-if="hover"
        :key="'video'"
        ref="videoRef"
        class="video-player"
        :src="src"
        :poster="poster"
        :autoplay="hover"
        :muted="muted"
        :lazy="true"
      />
    </Transition>
    <slot :hover="hover" />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import Resource from '~/components/resource/index';
import { transformImage } from '~/utils/';
import LazyVideo from './lazy-video.vue';

const videoRef = ref<HTMLVideoElement | null>(null);
const props = defineProps<{
  src: string;
  poster?: string;
  enable?: boolean;
  muted?: boolean;
  delay?: number; // 延时时间，默认300ms
}>();

const hover = ref(false);
let hoverTimer: NodeJS.Timeout | null = null;

const handleMouseOver = () => {
  if (hoverTimer) {
    clearTimeout(hoverTimer);
    hoverTimer = null;
  }

  hoverTimer = setTimeout(() => {
    hover.value = true;
  }, props.delay || 200);
};

const handleMouseLeave = () => {
  if (hoverTimer) {
    clearTimeout(hoverTimer);
    hoverTimer = null;
  }
  // 鼠标离开时立即生效
  hover.value = false;
};
</script>

<style lang="scss" scoped>
.hover-video {
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;

  .video-player,
  .video-poster {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .video-poster {
    display: block;
  }

  .video-player {
    display: none;
  }

  img,
  video {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  &.enable:hover {
    .video-player {
      display: block;
    }
    .video-poster {
      display: none;
    }
  }
}

// Fade transition styles
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
